module.exports = __webpack_public_path__ + "static/media/architecture.8e8f1ff9.png";